import Konva from "konva";
import { useEffect, useState } from "react";
import { Group, Image as KonvaImage, Rect } from "react-konva";
import type { CanvasIconEntity } from "./types";
import { buildIconDataUrl } from "./iconLibrary";

type CanvasIconNodeProps = {
  icon: CanvasIconEntity;
  isSelected: boolean;
  isLocked: boolean;
  toolMode: string;
  selectedStrokeWidth: number;
  dash: number[];
  opacity?: number;
  listening?: boolean;
  onSelect: (event: Konva.KonvaEventObject<MouseEvent>) => void;
  onDragStart: (event: Konva.KonvaEventObject<DragEvent>) => void;
  onDragMove: (event: Konva.KonvaEventObject<DragEvent>) => void;
  onDragEnd: (event: Konva.KonvaEventObject<DragEvent>) => void;
};

export function CanvasIconNode({
  icon,
  isSelected,
  isLocked,
  toolMode,
  selectedStrokeWidth,
  dash,
  opacity = 1,
  listening = true,
  onSelect,
  onDragStart,
  onDragMove,
  onDragEnd,
}: CanvasIconNodeProps) {
  const [image, setImage] = useState<HTMLImageElement | null>(null);

  useEffect(() => {
    const nextImage = new window.Image();
    nextImage.onload = () => setImage(nextImage);
    nextImage.src = buildIconDataUrl(icon.iconId, icon.mainColor);

    return () => {
      nextImage.onload = null;
    };
  }, [icon.iconId, icon.mainColor]);

  return (
    <Group
      x={icon.position.x}
      y={icon.position.y}
      rotation={icon.rotation}
      opacity={opacity}
      listening={listening}
      draggable={toolMode === "select" && !isLocked}
      onMouseDown={onSelect}
      onDragStart={onDragStart}
      onDragMove={onDragMove}
      onDragEnd={onDragEnd}
    >
      <Rect x={0} y={-icon.size} width={icon.size} height={icon.size} fill="rgba(255,255,255,0.01)" />
      {image && <KonvaImage image={image} x={0} y={-icon.size} width={icon.size} height={icon.size} />}
      {isSelected && (
        <Rect
          x={0}
          y={-icon.size}
          width={icon.size}
          height={icon.size}
          stroke="#1d5cab"
          strokeWidth={selectedStrokeWidth}
          dash={dash}
        />
      )}
    </Group>
  );
}
